var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPileStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.646 9.86a1.62 1.62 0 0 1-1.291 0l-7.83-3.626a.77.77 0 0 1 0-1.374l7.83-3.654a1.62 1.62 0 0 1 1.291 0l7.83 3.627a.77.77 0 0 1 0 1.373zM18.928 10.479l-8.379 3.86a1.37 1.37 0 0 1-1.14 0l-8.338-3.86M18.928 14.943l-8.379 3.86a1.37 1.37 0 0 1-1.14 0l-8.338-3.86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPileStack);
export default __webpack_public_path__ + "static/media/pile-stack.142352b476303a86b67f75580f490fbd.svg";
export { ForwardRef as ReactComponent };